// Colonne du board « Mes tâches » (vue Statuts) — droppable @dnd-kit.
// Une colonne = un statut. En-tête à état sémantique (pastille ronde 9px +
// titre Fraunces + compteur). Fond de colonne gris pour faire ressortir les
// cartes blanches (DESIGN.md §8 ter). PRÉSENTATION SEULE.

import { useDroppable } from '@dnd-kit/core'
import { DS } from '../../lib/ui'
import TaskCard from './TaskCard'
import { STATUS_DOT, COLUMN_BG } from './taches-ui'

export default function TaskColumn({ status, label, tasks, cfg, labelsById, onEdit, onToggleDone }) {
  const { setNodeRef, isOver } = useDroppable({ id: status })
  const dot = STATUS_DOT[status] || DS.marine

  return (
    <div
      ref={setNodeRef}
      data-testid={`task-column-${status}`}
      style={{
        flex: 1,
        minWidth: 264,
        background: COLUMN_BG,
        borderRadius: 14,
        padding: 12,
        border: isOver ? `2px dashed ${dot}` : '0.5px solid transparent',
        boxShadow: isOver ? `inset 0 0 0 9999px ${dot}10` : 'none',
        transition: 'box-shadow .12s',
      }}
    >
      <div
        style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          gap: 8, marginBottom: 12, padding: '0 2px',
        }}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
          <span style={{ width: 9, height: 9, borderRadius: '50%', background: dot, flexShrink: 0 }} />
          <span style={{ fontFamily: DS.fontDisplay, fontSize: 15, fontWeight: 600, color: DS.marineDark }}>
            {label}
          </span>
        </span>
        <span
          style={{
            fontFamily: DS.fontDisplay, fontSize: 12, fontWeight: 600, color: DS.textSecondary,
            background: DS.card, borderRadius: 9, padding: '1px 9px', flexShrink: 0,
          }}
        >
          {tasks.length}
        </span>
      </div>

      {tasks.length === 0 && (
        <div style={{ fontSize: 12, color: DS.textMuted, fontStyle: 'italic', padding: '8px 4px' }}>
          Aucune tâche
        </div>
      )}

      {tasks.map(t => (
        <TaskCard
          key={t.id}
          task={t}
          cfg={cfg}
          labelsById={labelsById}
          onEdit={onEdit}
          onToggleDone={onToggleDone}
        />
      ))}
    </div>
  )
}
